import React from 'react'

/**
 * TextHighlight component to highlight text with different colors and borders.
 *  #core
 * @param {string} highlight - the color to highlight the text. Can be "red", "yellow", "green", "blue", "darkRed", "amber", or "none".
 * @param {ReactNode} children - the text to be highlighted.
 * @param {boolean} pointer - whether the text should have a pointer cursor.
 * @param {boolean} boldValue - whether the text should be bold.
 * @param {string} fontSize - the font size of the text.
 * @param {object} style - additional styles to apply to the text.
 */
const TextHighlight = ({highlight, children, pointer, boldValue, fontSize="16px", style={}}) => {
    
    const highlightColor = () => {
        if(highlight=="red") return ({background:"red", textColor:"white"})
        if(highlight=="yellow")return ({background:"#FFBF00", textColor:"white"})
        if(highlight=="green") return ({background:"green", textColor:"white"})
        if(highlight=="blue") return ({background:"blue", textColor:"white"})
        if(highlight=="darkRed") return ({background:"#8B0000", textColor:"white"})
        if(highlight=="amber") return ({background:"#ff8503", textColor:"white"})
        if(highlight=="none") return ({textColor:"#324d67", border: "1px solid #324d67"})
      }
       
      const highlightStyle = {
          backgroundColor: highlightColor()?.background && highlightColor()?.background, 
          color:highlight && highlightColor()?.textColor, 
          padding:"4px", 
          paddingLeft:"5px", 
          paddingRight:"5px", 
          borderRadius:"4px",
          fontSize: fontSize,
          border: highlightColor()?.border && highlightColor()?.border, 
          cursor: pointer && "pointer",
         

          ...style
      }
  return (
    <>
    {!boldValue ?
    <span style={highlight && highlightStyle}>
        {children}
    </span> :
    <h3 style={highlight && highlightStyle}>
      {children}
    </h3> 
  }
  </>
  )
}

export default TextHighlight
